/* Insulation Warehouse Direct - MF ceiling & drywall partition calculators.
   Original code, plain JS, no libraries. Product data (variant ids, prices, availability)
   is rendered live by Liquid into a JSON script tag, so prices always match the store.
   Calculation rules follow British Gypsum White Book / Site Book guidance - see comments. */
(function () {
  'use strict';
  var PHONE = '03330 908479';
  var VAT = 0.2;
  var EPS = 1e-9;

  function up(x) { return Math.ceil(x - EPS); }
  function money(p) { return '\u00a3' + (p / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  /* Ex/Inc VAT switch (snippets/iwd-vat-init.liquid, 2026-09-27): prices render as ex + inc pairs and CSS shows the chosen one */
  function vm(p, o) { return window.IWDVAT ? IWDVAT.dual(p, o) : money(p) + ' ex VAT'; }
  function vt(p) { return window.IWDVAT && IWDVAT.isInc() ? money(IWDVAT.inc(p)) + ' inc VAT' : money(p) + ' ex VAT'; }
  function optTxt(o, pre, p, post) { o.setAttribute('data-iwd-ex', Math.round(p)); o.setAttribute('data-iwd-pre', pre); o.setAttribute('data-iwd-post', post || ''); o.textContent = pre + vt(p) + (post || ''); }
  var PRICE_TH = '<span class="iwd-vx">Price ex VAT</span><span class="iwd-vi">Price inc VAT</span>';
  function num(el, dflt) { var v = parseFloat(String(el && el.value || '').replace(',', '.')); return isFinite(v) ? v : dflt; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function readJSON(root, sel) { var el = root.querySelector(sel); if (!el) return {}; try { return JSON.parse(el.textContent); } catch (e) { return {}; } }

  /* "key = handle | extra | extra2" lines (section setting) */
  function parseMap(txt) {
    var m = {};
    String(txt || '').split(/\r?\n/).forEach(function (l) {
      l = l.trim(); if (!l || l.charAt(0) === '#') return;
      var i = l.indexOf('='); if (i < 0) return;
      var parts = l.slice(i + 1).split('|').map(function (s) { return s.trim(); });
      m[l.slice(0, i).trim()] = { handle: parts[0] || '', extra: parts[1] || '', extra2: parts[2] || '' };
    });
    return m;
  }

  /* Length of one bar from the product title, e.g. "Pack of 10 x 3.6m" -> 3.6 */
  function barLength(title, dflt) { var m = /x\s*(\d+(?:\.\d+)?)\s*m\b/i.exec(title || ''); return m ? parseFloat(m[1]) : dflt; }
  /* Items per box from title, e.g. "(Box of 1000)" -> 1000 */
  function boxQty(title, dflt) { var m = /box of\s*(\d+)/i.exec(title || '') || /\((\d+)\s*(?:\/|per)\s*box\)/i.exec(title || ''); return m ? parseInt(m[1], 10) : dflt; }
  /* Coverage per roll/pack from title, e.g. "(12m² roll)" -> 12 */
  function coverage(title) { var m = /(\d+(?:\.\d+)?)\s*m(?:\u00b2|2)(?![a-z0-9])/i.exec(title || ''); return m ? parseFloat(m[1]) : null; }
  /* Board sheet size from title, e.g. "2400 × 1200mm" -> {h:2.4, w:1.2} */
  function sheetSize(title) { var m = /(\d{3,4})\s*(?:x|×)\s*(\d{3,4})\s*mm/i.exec(title || ''); return m ? { h: parseInt(m[1], 10) / 1000, w: parseInt(m[2], 10) / 1000 } : { h: 2.4, w: 1.2 }; }
  /* Length variants (option named 'Length', e.g. "2.4m" / "2400mm"), sorted shortest first */
  function lengthVariants(p) {
    if (!p || !p.options || !p.variants) return [];
    var idx = -1; p.options.forEach(function (n, i) { if (/length/i.test(n)) idx = i; });
    if (idx < 0) return [];
    return p.variants.map(function (v) {
      var m = /(\d+(?:\.\d+)?)/.exec((v.opts || [])[idx] || ''), len = m ? parseFloat(m[1]) : NaN;
      if (len > 100) len = len / 1000;
      return { id: v.id, price: v.price, available: v.available, len: len, label: (v.opts || [])[idx] };
    }).filter(function (v) { return isFinite(v.len); }).sort(function (a, b) { return a.len - b.len; });
  }
  function withVariant(part, v) {
    var p = part.p, t = p.title, lenTxt = (Math.round(v.len * 100) / 100) + 'm';
    var title = /x\s*\d+(?:\.\d+)?\s*m\b/i.test(t) ? t.replace(/x\s*\d+(?:\.\d+)?\s*m\b/i, 'x ' + lenTxt) : t + ' (' + lenTxt + ')';
    var np = {}; for (var k in p) np[k] = p[k];
    np.price = v.price; np.variant = v.id; np.title = title; np.available = v.available;
    np.url = p.url + (p.url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + v.id;
    return { status: v.available ? 'ok' : 'unavailable', key: part.key, handle: part.handle, p: np, extra: part.extra, extra2: part.extra2 };
  }
  function isPack10(p) {
    if (!p) return false;
    var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
    return tags.indexOf('pack-of-10') > -1 || tags.indexOf('pack of 10') > -1 || /pack of 10/i.test(p.title || '');
  }
  /* Bar length of a single-variant section: Length option if present, else title, else default */
  function partLength(part, dflt) {
    if (!part || !part.p) return dflt;
    var lv = lengthVariants(part.p);
    if (lv.length) { var cur = lv.filter(function (v) { return v.id === part.p.variant; })[0] || lv[0]; return cur.len; }
    return barLength(part.p.title, dflt);
  }

  /* Cutting list: split each run into stock bars. Runs longer than one bar are joined with an
     overlap (lap) of `lap` metres; the short end pieces are then packed into bars
     first-fit-decreasing so offcuts are reused. Returns {bars, joins}. */
  function cutList(runs, bar, lap) {
    var bars = 0, joins = 0, pieces = [];
    runs.forEach(function (r) {
      if (r <= EPS) return;
      if (r <= bar + EPS) { pieces.push(r); return; }
      var rest = r - bar; bars += 1;
      var eff = bar - lap;
      var full = Math.floor((rest + EPS) / eff);
      bars += full; joins += full;
      var rem = rest - full * eff;
      if (rem > 0.005) { pieces.push(Math.min(bar, rem + lap)); joins += 1; }
    });
    pieces.sort(function (a, b) { return b - a; });
    var open = [];
    pieces.forEach(function (p) {
      for (var i = 0; i < open.length; i++) { if (open[i] + EPS >= p) { open[i] -= p; return; } }
      open.push(bar - p);
    });
    return { bars: bars + open.length, joins: joins };
  }

  function Calc(root) {
    this.root = root;
    this.products = readJSON(root, '[data-iwd-products]');
    this.map = parseMap((root.querySelector('[data-iwd-map]') || {}).textContent);
  }
  /* Resolve a part key to a live product */
  Calc.prototype.part = function (key) {
    var e = this.map[key];
    if (!e || !e.handle) return { status: 'notstocked', key: key };
    var p = this.products[e.handle];
    if (!p || !p.variant) return { status: 'unavailable', key: key, handle: e.handle, extra: e.extra, extra2: e.extra2 };
    return { status: p.available ? 'ok' : 'unavailable', key: key, handle: e.handle, p: p, extra: e.extra, extra2: e.extra2 };
  };
  Calc.prototype.keys = function (prefix) { var out = []; for (var k in this.map) if (k.indexOf(prefix) === 0) out.push(k); return out; };

  /* Build a result row.  need = quantity of base units (lengths, screws, sheets, m²...)
     perPack = base units per Shopify quantity (10 lengths, 1000 screws, 1 sheet, 12 m²...) */
  function row(part, label, need, unit, perPack, opts) {
    opts = opts || {};
    var r = { label: label, need: need, unit: unit, perPack: perPack, part: part, note: opts.note || '', group: opts.group || 'main', packWord: opts.packWord || 'pack', needText: opts.needText || '' };
    r.packs = need > 0 ? up(need / perPack) : 0;
    if (part.status === 'ok') {
      r.price = part.p.price; r.total = r.price * r.packs;
      r.perLength = isPack10(part.p) ? Math.round(part.p.price / 10) : null;
    } else { r.price = null; r.total = 0; }
    return r;
  }

  Calc.prototype.render = function (rows, out) {
    var html = '', ex = 0, missing = 0, items = [];
    html += '<table class="iwd-table"><thead><tr><th>Part</th><th class="num">Needed</th><th class="num">Buy</th><th class="num">' + PRICE_TH + '</th><th class="num">Line total</th></tr></thead><tbody>';
    rows.forEach(function (r) {
      if (!r || r.need <= 0) return;
      var p = r.part, prodHtml = '', buy = '', price = '', total = '';
      var needTxt = r.needText || (r.need + ' ' + (r.need === 1 ? r.unit.replace(/s$/, '') : r.unit));
      if (p.status === 'ok') {
        prodHtml = '<a class="iwd-prod" href="' + esc(p.p.url) + '">' + esc(p.p.title) + '</a>';
        buy = r.packs + ' ' + (r.packs === 1 ? r.packWord : r.packWord + (/(x|s)$/.test(r.packWord) ? 'es' : 's'));
        price = vm(r.price, { align: 'end' }) + (r.perLength ? '<span class="iwd-sub">' + vm(r.perLength, { style: 'single' }) + ' per length</span>' : '');
        total = vm(r.total, { align: 'end' });
        ex += r.total;
        items.push({ id: p.p.variant, quantity: r.packs });
      } else {
        missing++;
        var msg = p.status === 'call' ? p.msg : p.status === 'notstocked' ? 'Not stocked online, call ' + PHONE : 'Currently unavailable online, call ' + PHONE;
        prodHtml = '<span class="iwd-status">' + msg + '</span>';
        buy = '&ndash;'; price = '&ndash;'; total = '&ndash;';
      }
      html += '<tr class="' + (p.status === 'ok' ? '' : 'is-off') + '"><td><span class="iwd-part">' + esc(r.label) + '</span>' + prodHtml + (r.note ? '<span class="iwd-sub">' + esc(r.note) + '</span>' : '') + '</td>' +
        '<td class="num" data-label="Needed">' + esc(needTxt) + '</td><td class="num" data-label="Buy">' + buy + '</td><td class="num" data-label="Price">' + price + '</td><td class="num" data-label="Line total">' + total + '</td></tr>';
    });
    html += '</tbody></table>';
    var vat = Math.round(ex * VAT);
    html += '<div class="iwd-totals"><div><span>Total ex VAT</span><span data-iwd-total-ex>' + money(ex) + '</span></div><div><span>VAT (20%)</span><span>' + money(vat) + '</span></div><div class="iwd-grand"><span>Total inc VAT</span><span data-iwd-total-inc>' + money(ex + vat) + '</span></div></div>';
    if (missing) html += '<p class="iwd-note">Items marked &lsquo;call&rsquo; are not included in the totals or the basket. Call us on <a href="tel:03330908479">' + PHONE + '</a> and we&rsquo;ll price them for you.</p>';
    out.innerHTML = html;
    this.items = items;
    this.hasRows = rows.some(function (r) { return r && r.need > 0; });
    this.totalEx = ex;
    return items;
  };

  Calc.prototype.bindBasket = function (btn, msg) {
    var self = this;
    btn.addEventListener('click', function () {
      var items = (self.items || []).filter(function (i) { return i.quantity > 0; });
      if (!items.length) { msg.textContent = self.hasRows ? 'These items can\u2019t be ordered online right now - please call ' + PHONE + '.' : 'Nothing to add yet - check your measurements.'; msg.className = 'iwd-msg is-error'; return; }
      btn.disabled = true; msg.className = 'iwd-msg'; msg.textContent = 'Adding to your basket\u2026';
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Could not add to basket');
          window.location.href = root + 'cart';
        })
        .catch(function (e) { btn.disabled = false; msg.className = 'iwd-msg is-error'; msg.textContent = e.message + '. Please try again or call ' + PHONE + '.'; });
    });
  };

  /* ---------------- MF suspended ceiling ----------------
     British Gypsum GypCeiling MF (White Book & Site Book good practice guide):
     - MF7 primary support channels at max 1200mm centres; laps 150mm min, 2 wafer head screws.
     - Suspension (hangers) at max 1200mm centres along each MF7 (1200 x 1200 grid);
       hangers fixed to MF7 with 2 wafer head screws each. MF7 ends rest on the MF6 perimeter.
     - MF5 ceiling sections at max 450mm centres, at right angles under the MF7, joined to each
       MF7 with an MF9 connecting clip; MF5 laps 150mm min, screwed twice through each flange.
     - MF6 perimeter channel fixed to walls at max 600mm centres.
     - Boards fixed with drywall screws at 230mm centres in the field, 150mm at board ends. */
  function mfCompute(c, v) {
    var L = Math.max(v.a, v.b), W = Math.min(v.a, v.b);
    var cm = v.centres / 1000, waste = 1 + v.waste / 100;
    var n7 = Math.max(1, up(L / 1.2) - 1);                 // MF7 rows (span across the short side W)
    var n5 = Math.max(1, up(W / cm) - 1);                  // MF5 rows between the perimeter channels (run along L)
    var hPer7 = Math.max(1, up(W / 1.2) - 1);              // hangers per MF7 (ends sit on MF6)
    var res = { L: L, W: W, n7: n7, n5: n5, hangers: n7 * hPer7, clips: n5 * n7, area: L * W, perim: 2 * (L + W) };
    var b = v.brand;
    var p5 = c.part('mf5.' + b), p7 = c.part('mf7.' + b), p6 = c.part('mf6a.' + b), ph = c.part('hanger.' + b);
    var bar = function (p) { return partLength(p, 3.6); };
    var cut7 = cutList(repeat(W, n7), bar(p7), 0.15);
    var cut5 = cutList(repeat(L, n5), bar(p5), 0.15);
    var cut6 = cutList([L, L, W, W], bar(p6), 0);
    var hangerCut = v.drop + 0.1;                          // drop + 100mm for bent feet
    var hBar = partLength(ph, 3.0);
    var perBar = Math.max(1, Math.floor((hBar + EPS) / hangerCut));
    res.hangerLengths = up(res.hangers / perBar);
    res.mf7 = cut7.bars; res.mf5 = cut5.bars; res.mf6 = cut6.bars; res.laps7 = cut7.joins; res.laps5 = cut5.joins;
    res.wafer = up((res.hangers * 2 + cut7.joins * 2 + cut5.joins * 4) * waste);
    res.clipsW = up(res.clips * waste);
    var rows = [];
    rows.push(row(p7, 'MF7 primary channel', res.mf7, 'lengths', 10, { note: n7 + ' run(s) of ' + W.toFixed(2) + 'm at max 1200mm centres' }));
    rows.push(row(p5, 'MF5 furring (ceiling) section', res.mf5, 'lengths', 10, { note: n5 + ' run(s) of ' + L.toFixed(2) + 'm at ' + v.centres + 'mm centres' }));
    rows.push(row(p6, 'MF6A perimeter channel', res.mf6, 'lengths', 10, { note: res.perim.toFixed(2) + 'm perimeter' }));
    rows.push(row(ph, 'Hangers: 25 x 25mm galvanised angle', res.hangerLengths, 'lengths', 10, { note: res.hangers + ' hangers cut at ' + Math.round(hangerCut * 1000) + 'mm (' + perBar + ' per length)' }));
    var clip = c.part('mf9');
    rows.push(row(clip, 'MF9 connecting clips', res.clipsW, 'clips', clip.p ? boxQty(clip.p.title, parseInt(clip.extra, 10) || 200) : 200, { packWord: 'box', note: res.clips + ' crossings + wastage' }));
    var wf = c.part('screws.wafer');
    rows.push(row(wf, 'Wafer head screws (metal to metal)', res.wafer, 'screws', wf.p ? boxQty(wf.p.title, 1000) : 1000, { packWord: 'box', note: '2 per hanger, 2 per MF7 lap, 4 per MF5 lap' }));
    if (v.fixings) {
      var soffit = c.part('fix.soffit'), wall = c.part('fix.wall');
      var wallFix = 0; [L, L, W, W].forEach(function (s) { wallFix += up(s / 0.6) + 1; });
      res.soffitFix = up(res.hangers * waste); res.wallFix = up(wallFix * waste);
      rows.push(row(soffit, 'Soffit fixings (concrete soffit)', res.soffitFix, 'fixings', soffit.p ? boxQty(soffit.p.title, 100) : 100, { packWord: 'box', note: '1 per hanger - use fixings suited to your soffit' }));
      rows.push(row(wall, 'Perimeter wall fixings (masonry)', res.wallFix, 'fixings', wall.p ? boxQty(wall.p.title, 200) : 200, { packWord: 'box', note: 'MF6A fixed at max 600mm centres' }));
    }
    if (v.board && v.board !== 'none') {
      var pb = c.part(v.board);
      var sz = pb.p ? sheetSize(pb.p.title) : { h: 2.4, w: 1.2 };
      var sheetArea = sz.h * sz.w;
      res.sheets = up(res.area * waste / sheetArea);
      /* screws per sheet: MF5 crossed by the sheet length x fixings at 230mm along each MF5,
         plus extra fixings at the two board ends (150mm centres) */
      var supports = Math.floor((sz.h + EPS) / cm) + 1;
      var along = up(sz.w / 0.23) + 1, ends = up(sz.w / 0.15) + 1;
      var perSheet = supports * along + 2 * Math.max(0, ends - along);
      res.screwsPerSheet = perSheet;
      res.boardScrews = up(res.sheets * perSheet * waste);
      rows.push(row(pb, 'Plasterboard', res.sheets, 'sheets', 1, { packWord: 'sheet', note: res.area.toFixed(2) + 'm\u00b2 + ' + v.waste + '% wastage' }));
      var bs = c.part('screws.board');
      rows.push(row(bs, 'Drywall screws 25mm (board to MF5)', res.boardScrews, 'screws', bs.p ? boxQty(bs.p.title, 1000) : 1000, { packWord: 'box', note: 'about ' + perSheet + ' per sheet' }));
    }
    res.rows = rows;
    return res;
  }
  function repeat(x, n) { var a = []; for (var i = 0; i < n; i++) a.push(x); return a; }

  function initMF(root) {
    var c = new Calc(root);
    var f = function (n) { return root.querySelector('[name="' + n + '"]'); };
    var out = root.querySelector('[data-iwd-results]'), sum = root.querySelector('[data-iwd-summary]'), err = root.querySelector('[data-iwd-error]');
    var brandSel = f('brand'), boardSel = f('board');
    // board options (only boards set up in the part map; unavailable ones are flagged)
    c.keys('board.').forEach(function (k) {
      var pt = c.part(k), o = document.createElement('option');
      o.value = k; o.textContent = (c.map[k].extra || (pt.p && pt.p.title) || k) + (pt.status === 'ok' ? '' : ' (call us)');
      boardSel.appendChild(o);
    });
    if (c.map['board.default'] === undefined && boardSel.querySelector('option[value="board.te125"]')) boardSel.value = 'board.te125';
    function vals(brand) {
      return { a: num(f('length'), 0), b: num(f('width'), 0), drop: num(f('drop'), 0.3), centres: parseInt(f('centres').value, 10) || 450,
        waste: Math.max(0, Math.min(50, num(f('waste'), 10))), board: boardSel.value, brand: brand || brandSel.value, fixings: f('fixings').checked };
    }
    // default brand = cheaper overall for the current inputs (Alpha if equal)
    (function () {
      var v = vals('alpha'); if (!(v.a > 0 && v.b > 0)) { v.a = 4; v.b = 3; }
      var tot = function (b) { v.brand = b; var r = mfCompute(c, v), t = 0, miss = 0; r.rows.forEach(function (x) { if (x.part.status === 'ok') t += x.total; else miss++; }); return t + miss * 1e7; };
      var ta = tot('alpha'), th = tot('hadley');
      brandSel.value = th < ta ? 'hadley' : 'alpha';
      var hint = root.querySelector('[data-iwd-brand-hint]');
      if (hint) hint.textContent = ta === th ? 'Alpha and Hadley are currently the same price.' : ('Defaulted to ' + (th < ta ? 'Hadley' : 'Alpha') + ', the cheaper range for this ceiling.');
    })();
    function run() {
      var v = vals();
      err.textContent = '';
      if (!(v.a > 0 && v.b > 0) || v.a > 2000 || v.b > 2000) { err.textContent = 'Enter a room length and width in metres (up to 2,000m each). Only know the area? Enter 1 x your m\u00b2, e.g. 1 x 500.'; out.innerHTML = ''; sum.innerHTML = ''; c.items = []; return; }
      if (!(v.drop >= 0.05 && v.drop <= 2.9)) { err.textContent = 'Enter a ceiling drop between 0.05m and 2.9m (for bigger drops please call us).'; out.innerHTML = ''; sum.innerHTML = ''; c.items = []; return; }
      /* 6 Oct 2026: a side of exactly 1m is read as "I know the m2" (customers type 1 x 500 for 500 m2).
         Work it out as a square room of the same area so the perimeter, MF7 and hangers aren't inflated
         by a 500m-long, 1m-wide corridor. Any other size (including 0.9m or 1.1m corridors) is laid out as entered. */
      var asArea = Math.abs(Math.min(v.a, v.b) - 1) < 1e-9 && Math.max(v.a, v.b) > 1, typed = v.a * v.b;
      if (asArea) { v.a = v.b = Math.sqrt(typed); }
      var r = mfCompute(c, v);
      sum.innerHTML = (asArea ? '<span data-iwd-areanote>Read as a total of <b>' + typed.toFixed(2) + 'm\u00b2</b>, worked out as a square room of that size (about ' + v.a.toFixed(2) + 'm x ' + v.a.toFixed(2) + 'm). Measuring a real 1m-wide corridor? Enter the width as 0.99 or 1.01 for the exact layout.</span>' : '') + '<span>Ceiling area <b>' + r.area.toFixed(2) + 'm\u00b2</b></span><span>Perimeter <b>' + r.perim.toFixed(2) + 'm</b></span><span>MF7 rows <b>' + r.n7 + '</b></span><span>MF5 rows <b>' + r.n5 + '</b></span><span>Hangers <b>' + r.hangers + '</b></span>';
      c.render(r.rows, out);
      root.dispatchEvent(new CustomEvent('iwd:calculated', { detail: r }));
      window.IWD_LAST = r;
    }
    root.querySelector('form').addEventListener('input', run);
    root.querySelector('form').addEventListener('change', run);
    root.querySelector('form').addEventListener('submit', function (e) { e.preventDefault(); run(); });
    c.bindBasket(root.querySelector('[data-iwd-add]'), root.querySelector('[data-iwd-msg]'));
    run();
  }

  /* ---------------- Drywall partition (metal stud wall) ----------------
     British Gypsum GypWall Classic (White Book / Site Book):
     - Floor & ceiling channel (track) fixed at head and base at max 600mm centres.
     - 'C' studs at 600mm centres (400mm option), friction-fitted into the channels, plus
       studs at each abutment/end. Studs extended by overlapping min 600mm.
     - Door openings: stud each side of the opening, sleeved to door height with channel;
       channel across the head of the opening, cut 300mm long (150mm each side) and bent down.
     - Single layer boards screwed at 300mm centres (200mm at external angles).
       Screws must be at least 10mm longer than the board thickness (lining). */
  function ptCompute(c, v) {
    var L = v.length, H = v.height, cm = v.centres / 1000, waste = 1 + v.waste / 100;
    var s = v.stud, b = v.brand;
    var pStud = c.part('stud.' + s + '.' + b), pTrack = c.part('track.' + s + '.' + b);
    var studBar = partLength(pStud, 3.0), trackBar = partLength(pTrack, 3.0);
    /* Stud length: shortest stocked Length variant that is at least the wall height.
       Falls back to the single variant (extended with a 600mm overlap) if there is no Length option. */
    var tooTall = false, lv = pStud.p ? lengthVariants(pStud.p) : [];
    if (lv.length) {
      var avail = lv.filter(function (x) { return x.available; }), pool = avail.length ? avail : lv;
      var pick = pool.filter(function (x) { return x.len >= H - 0.005; })[0];
      if (pick) { pStud = withVariant(pStud, pick); studBar = pick.len; }
      else {
        tooTall = true;
        pStud = { status: 'call', key: pStud.key, handle: pStud.handle, msg: 'Wall is taller than our longest ' + s + 'mm stud (' + pool[pool.length - 1].len + 'm) - call ' + PHONE };
      }
    }
    var doors = v.doors ? v.doorCount : 0, dW = v.doorWidth, dH = Math.min(v.doorHeight, H);
    var positions = up(L / cm) + 1;                        // studs at centres incl. both ends
    var jamb = doors * 2;                                  // extra stud each side of every opening
    var removed = doors ? Math.min(Math.max(0, positions - 2), doors * Math.floor((dW + EPS) / cm)) : 0; // regular studs that fall inside openings
    var studRuns = repeat(H, positions + jamb - removed);
    // short studs above each door head (at stud centres) - usually from offcuts
    var above = H - dH;
    if (doors && above > 0.05) { var cr = Math.max(1, up(dW / cm) - 1); for (var d = 0; d < doors; d++) for (var k = 0; k < cr; k++) studRuns.push(above); }
    var studCut = cutList(studRuns, studBar, 0.6);         // 600mm overlap where studs are extended
    var trackRuns = [L, Math.max(0, L - doors * dW)];      // head + floor (floor stops at openings)
    for (var i = 0; i < doors; i++) { trackRuns.push(dW + 0.3); trackRuns.push(dH); trackRuns.push(dH); }
    var trackCut = cutList(trackRuns, trackBar, 0);
    var res = { L: L, H: H, positions: positions, jamb: jamb, studs: studCut.bars, track: trackCut.bars, doors: doors };
    res.area = Math.max(0, L * H - doors * dW * dH);
    var rows = [];
    res.studLength = tooTall ? null : studBar;
    if (tooTall) res.studs = positions + jamb - removed;
    rows.push(row(pStud, s + 'mm C studs' + (tooTall ? '' : ' (' + (Math.round(studBar * 100) / 100) + 'm)'), res.studs, 'lengths', 10, { group: 'metal', note: positions + ' studs at ' + v.centres + 'mm centres' + (jamb ? ' + ' + jamb + ' door jamb studs' + (removed ? ' - ' + removed + ' in openings' : '') : '') + (H > studBar + 0.005 && !tooTall ? ' (extended with 600mm overlap)' : '') }));
    rows.push(row(pTrack, (s + 2) + 'mm U track (floor & head)', res.track, 'lengths', 10, { group: 'metal', note: 'head + floor' + (doors ? ' + door heads & jamb sleeves' : '') }));
    if (v.apr) {
      var key = 'apr.' + v.aprThk, pa = c.part(key);
      var cov = pa.p ? coverage(pa.p.title) : null;
      if (pa.status === 'ok' && cov) {
        res.aprRolls = up(res.area * waste / cov);
        rows.push(row(pa, 'Acoustic partition roll (' + v.aprThk + 'mm)', res.aprRolls, 'rolls', 1, { group: 'apr', packWord: 'roll', needText: (res.area * waste).toFixed(1) + 'm\u00b2', note: res.area.toFixed(2) + 'm\u00b2 wall + ' + v.waste + '% wastage, ' + cov + 'm\u00b2 per roll' }));
      } else {
        var pcall = pa.status === 'ok' ? { status: 'call', key: pa.key, handle: pa.handle, msg: 'Roll coverage not listed - call ' + PHONE } : pa;
        rows.push(row(pcall, 'Acoustic partition roll (' + v.aprThk + 'mm)', 1, 'm\u00b2', 1, { group: 'apr', needText: (res.area * waste).toFixed(1) + 'm\u00b2' }));
      }
    }
    if (v.boards) {
      var pb = c.part(v.board);
      var sz = pb.p ? sheetSize(pb.p.title) : { h: 2.4, w: 1.2 };
      var faces = v.sides * v.layers;
      var sheetArea = sz.h * sz.w;
      // sheets: board run vertically; wall height > sheet height needs extra cut pieces
      var cols = up(L / sz.w);
      var sheetsFace = Math.max(up(res.area * waste / sheetArea), 0);
      if (H > sz.h + 0.02) {                               // taller than a sheet: full sheets + top-up pieces cut from spare sheets
        var fullPer = Math.floor((H + EPS) / sz.h), rem = H - fullPer * sz.h;
        var piecesPerSheet = rem > 0.01 ? Math.max(1, Math.floor((sz.h + EPS) / rem)) : 1;
        var net = cols * fullPer + (rem > 0.01 ? up(cols / piecesPerSheet) : 0);
        sheetsFace = Math.max(sheetsFace, up(net * waste));
      }
      res.sheets = sheetsFace * faces;
      var studsPerSheet = Math.round(sz.w / cm) + 1, rowsPerStud = up(sz.h / 0.3) + 1;
      var perSheet = studsPerSheet * rowsPerStud;
      var layer1 = up(sheetsFace * v.sides * perSheet * waste);
      var layer2 = v.layers > 1 ? layer1 : 0;
      res.screws1 = layer1; res.screws2 = layer2;
      rows.push(row(pb, 'Plasterboard (' + faces + ' face' + (faces > 1 ? 's' : '') + ')', res.sheets, 'sheets', 1, { group: 'boards', packWord: 'sheet', note: sheetsFace + ' per face: ' + res.area.toFixed(2) + 'm\u00b2 + ' + v.waste + '% wastage' + (H > sz.h + 0.02 ? '. Back horizontal joints with a fixing T or strap' : '') }));
      var thick = /15mm/.test(pb.p ? pb.p.title : (c.map[v.board] && c.map[v.board].extra) || '') ? 15 : 12.5;
      var s1 = c.part(thick === 15 ? 'screws.l1.15' : 'screws.l1'), s2 = c.part('screws.l2');
      rows.push(row(s1, 'Drywall screws ' + (s1.extra || '') + ' (' + (v.layers > 1 ? 'first layer' : 'boards to studs') + ')', layer1, 'screws', s1.p ? boxQty(s1.p.title, 1000) : 1000, { group: 'boards', packWord: 'box', note: 'about ' + perSheet + ' per sheet at 300mm centres' }));
      if (layer2) rows.push(row(s2, 'Drywall screws ' + (s2.extra || '') + ' (second layer)', layer2, 'screws', s2.p ? boxQty(s2.p.title, 500) : 500, { group: 'boards', packWord: 'box' }));
    }
    if (v.tape) {
      var pt = c.part('tape.scrim'), pc = c.part('tape.corner');
      // joints: vertical joints between sheets + horizontal joints if wall taller than sheet, outer layer only
      var szT = { h: 2.4, w: 1.2 };
      if (v.boards) { var pbt = c.part(v.board); if (pbt.p) szT = sheetSize(pbt.p.title); }
      var vJoints = Math.max(0, up(L / szT.w) - 1) * H;
      var hJoints = H > szT.h + 0.02 ? L : 0;
      var perimJ = 2 * H + L;                              // wall/ceiling and wall/wall angles
      var jointM = (vJoints + hJoints + perimJ) * v.sides * waste;
      var tapeRoll = pt.p ? (parseFloat((/x\s*(\d+)\s*m\b/i.exec(pt.p.title) || [0, 90])[1]) || 90) : 90;
      res.tapeM = Math.round(jointM);
      rows.push(row(pt, 'Scrim (joint) tape', res.tapeM, 'm', tapeRoll, { group: 'tape', packWord: 'roll', needText: res.tapeM + 'm' }));
      if (v.corners > 0) {
        var cornerM = v.corners * H * waste, cRoll = pc.p ? (parseFloat((/(\d+)\s*m\b/i.exec(pc.p.title) || [0, 30])[1]) || 30) : 30;
        rows.push(row(pc, 'Metal corner tape (external corners)', Math.round(cornerM * 10) / 10, 'm', cRoll, { group: 'tape', packWord: 'roll', needText: (Math.round(cornerM * 10) / 10) + 'm' }));
      }
    }
    res.rows = rows;
    return res;
  }

  function initPartition(root) {
    var c = new Calc(root);
    var f = function (n) { return root.querySelector('[name="' + n + '"]'); };
    var out = root.querySelector('[data-iwd-results]'), sum = root.querySelector('[data-iwd-summary]'), err = root.querySelector('[data-iwd-error]');
    var studSel = f('stud'), brandSel = f('brand'), boardSel = f('board'), aprSel = f('apr_thk');
    // stud sizes: only sizes where a stud is set up in the part map for either brand
    var sizes = {};
    c.keys('stud.').forEach(function (k) { var s = k.split('.')[1]; sizes[s] = true; });
    Object.keys(sizes).map(Number).sort(function (a, b) { return a - b; }).forEach(function (s) {
      var o = document.createElement('option'); o.value = s; o.textContent = s + 'mm C stud (' + (s + 2) + 'mm track)'; studSel.appendChild(o);
    });
    if (sizes['70']) studSel.value = '70';
    c.keys('board.').forEach(function (k) {
      var pt = c.part(k), o = document.createElement('option');
      o.value = k; o.textContent = (c.map[k].extra || (pt.p && pt.p.title) || k) + (pt.status === 'ok' ? '' : ' (call us)');
      boardSel.appendChild(o);
    });
    if (boardSel.querySelector('option[value="board.te125.2400"]')) boardSel.value = 'board.te125.2400';
    var aprKeys = c.keys('apr.').map(function (k) { return parseInt(k.split('.')[1], 10); }).sort(function (a, b) { return a - b; });
    aprKeys.forEach(function (t) { var pt = c.part('apr.' + t), o = document.createElement('option'); o.value = t; o.textContent = t + 'mm' + (pt.p ? ' - ' + pt.p.title : ' (call us)'); aprSel.appendChild(o); });
    var aprTouched = false;
    aprSel.addEventListener('change', function () { aprTouched = true; });
    function bestApr(stud) {
      // match roll thickness to stud width: 50 -> 25mm, 60/70 -> 50mm, 92 -> 75mm, 146 -> 100mm (nearest stocked)
      var want = stud <= 50 ? 25 : stud <= 70 ? 50 : stud <= 92 ? 75 : 100, best = null;
      aprKeys.forEach(function (t) { if (t <= stud && (best === null || Math.abs(t - want) < Math.abs(best - want))) best = t; });
      return best === null ? aprKeys[0] : best;
    }
    function toggle(name) { var cb = f(name), body = root.querySelector('[data-iwd-opt="' + name + '"]'); if (body) body.hidden = !cb.checked; }
    function vals(brand) {
      return { length: num(f('length'), 0), height: num(f('height'), 0), stud: parseInt(studSel.value, 10), centres: parseInt(f('centres').value, 10) || 600,
        brand: brand || brandSel.value, waste: Math.max(0, Math.min(50, num(f('waste'), 10))),
        apr: f('apr').checked, aprThk: parseInt(aprSel.value, 10),
        doors: f('doors').checked, doorCount: Math.max(0, Math.min(20, Math.round(num(f('door_count'), 1)))), doorWidth: num(f('door_width'), 0.9), doorHeight: num(f('door_height'), 2.1),
        boards: f('boards').checked, board: boardSel.value, sides: parseInt(f('sides').value, 10) || 2, layers: parseInt(f('layers').value, 10) || 1,
        tape: f('tape').checked, corners: Math.max(0, Math.round(num(f('corners'), 0))) };
    }
    function pickBrand() {
      var v = vals('alpha'); if (!(v.length > 0 && v.height > 0)) { v.length = 5; v.height = 2.4; }
      v.apr = false; v.boards = false; v.tape = false;
      var tot = function (b) { v.brand = b; var r = ptCompute(c, v), t = 0, miss = 0; r.rows.forEach(function (x) { if (x.part.status === 'ok') t += x.total; else miss++; }); return t + miss * 1e7; };
      var ta = tot('alpha'), th = tot('hadley');
      brandSel.value = th < ta ? 'hadley' : 'alpha';
      var hint = root.querySelector('[data-iwd-brand-hint]');
      if (hint) hint.textContent = ta === th ? 'Alpha and Hadley are currently the same price for this size.' : ('Defaulted to ' + (th < ta ? 'Hadley' : 'Alpha') + ', the cheaper range for this size.');
    }
    var brandTouched = false;
    brandSel.addEventListener('change', function () { brandTouched = true; });
    studSel.addEventListener('change', function () { if (!brandTouched) pickBrand(); });
    function run() {
      ['apr', 'doors', 'boards', 'tape'].forEach(toggle);
      if (!aprTouched && aprKeys.length) aprSel.value = String(bestApr(parseInt(studSel.value, 10)));
      var v = vals();
      err.textContent = '';
      if (!(v.length >= 0.3 && v.length <= 100) || !(v.height >= 0.5 && v.height <= 6)) { err.textContent = 'Enter a wall length (0.3 to 100m) and height (0.5 to 6m). For taller walls please call us.'; out.innerHTML = ''; sum.innerHTML = ''; c.items = []; return; }
      if (v.doors && (v.doorWidth * v.doorCount >= v.length || v.doorWidth <= 0)) { err.textContent = 'Door openings are wider than the wall - check the door width and number.'; }
      var r = ptCompute(c, v);
      sum.innerHTML = '<span>Wall <b>' + v.length.toFixed(2) + 'm x ' + v.height.toFixed(2) + 'm</b></span><span>Stud positions <b>' + r.positions + '</b></span>' + (r.jamb ? '<span>Door jamb studs <b>' + r.jamb + '</b></span>' : '') + '<span>Area to line <b>' + r.area.toFixed(2) + 'm\u00b2</b></span>';
      c.render(r.rows, out);
      window.IWD_LAST = r;
    }
    pickBrand();
    root.addEventListener('input', run); root.addEventListener('change', run);
    root.querySelectorAll('form').forEach(function (fm) { fm.addEventListener('submit', function (e) { e.preventDefault(); run(); }); });
    c.bindBasket(root.querySelector('[data-iwd-add]'), root.querySelector('[data-iwd-msg]'));
    run();
  }

  window.IWDCalc = { lengthVariants: lengthVariants, cutList: cutList, mfCompute: mfCompute, ptCompute: ptCompute, Calc: Calc, parseMap: parseMap, barLength: barLength, boxQty: boxQty, coverage: coverage, sheetSize: sheetSize };
  function boot() {
    document.querySelectorAll('[data-iwd-calc]').forEach(function (root) {
      if (root.dataset.iwdReady) return; root.dataset.iwdReady = '1';
      if (root.dataset.iwdCalc === 'mf') initMF(root); else if (root.dataset.iwdCalc === 'partition') initPartition(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
